var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 60,
    viewBox: "0 0 50 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.32 46.23V56.34H1V1H42.32V37.47",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72998 11.38H31.72",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72998 18.3H21.21",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72998 25.21H31.72",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72998 32.13H31.72",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72998 39.05H31.72",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72998 45.97H24.35",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3199 58.14C45.7054 58.14 48.4499 55.3955 48.4499 52.01C48.4499 48.6245 45.7054 45.88 42.3199 45.88C38.9344 45.88 36.1899 48.6245 36.1899 52.01C36.1899 55.3955 38.9344 58.14 42.3199 58.14Z",
    fill: "white",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.11 41.91C38.11 39.59 39.99 37.7 42.32 37.7C44.65 37.7 46.53 39.58 46.53 41.91V46.89",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.32 53.63C43.2147 53.63 43.9399 52.9047 43.9399 52.01C43.9399 51.1153 43.2147 50.39 42.32 50.39C41.4252 50.39 40.7 51.1153 40.7 52.01C40.7 52.9047 41.4252 53.63 42.32 53.63Z",
    fill: "#5D68B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.45,
    height: 59.14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.e47c4ddf469d0e090df924d6109bc439.svg";
export { ForwardRef as ReactComponent };